export default [
  {
    path: '/admin/floating-cashiers',
    name: 'floating-cashier',
    meta: { requiresAuth: true },
    component: () =>
      import('@/pages/floating-cashier/index.vue')
  },
]
